import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'none',
  historyBasename: '/',
  htmlTitle: 'Feedback',
  htmlTitleLangKey: 'feedbackPublicUi.htmlTitle',
  logFetchErrors: {
    options: {
      ignoreErrors: [/failed with status (0|403|404|429)/, /hub-http (0|403|404|429)/, /hub-http(.*) - (0|403|404|429)/, 'HSFX eligibility fetch failed', 'Missing valid Google font SVG', /Loading chunk ([A-Z0-9a-z-~_]+) failed./i, /Loadable: error loading split chunk/i, /removeEventListener is not a function/, /usage-tracker-js event error/, /Object Not Found Matching Id:[0-9]+/]
    }
  },
  createRootApi: 'tests-only'
});